export default class InvalidEmailAddressError extends Error {}
